import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CampaignType } from "@front/m19-api-client";
import { StrategyPageService } from "../strategy-page.service";
import { SdStrategyTargetingListComponent } from "./sd-strategy-targeting-list.component";

@Component({
  selector: "app-strategy-page-sd-targetings",
  imports: [SdStrategyTargetingListComponent],
  template: ` <app-sd-strategy-targeting-list [strategy]="strategy()" /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageSdTargetingsComponent {
  private readonly strategyPageService = inject<StrategyPageService<CampaignType.SD>>(StrategyPageService);
  strategy = this.strategyPageService.strategy;
}
